export const INPUT_ERROR_TYPES = {
  MAX_VALUE: 'input.maxValue',
  MIN_LENGTH: 'input.minLength',
  MIN_VALUE: 'input.minValue',
  REQUIRED: 'input.required',
};
